.field {
  display: grid;
  gap: var(--space-2);
}

.label {
  font-weight: 600;
  font-size: var(--text-sm);
  letter-spacing: 0.01em;
}

/*
 * The prefix sits inside the control's border rather than beside it, so the dollar sign and
 * the amount read as one figure. `focus-within` moves the platform focus ring onto the whole
 * control, which is what a sighted keyboard user is actually pointing at.
 */
.control {
  display: flex;
  align-items: stretch;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  background: var(--surface-elevated);
  min-block-size: 44px;
}

.control:focus-within {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.prefix {
  display: flex;
  align-items: center;
  padding-inline: var(--space-3);
  border-inline-end: 1px solid var(--border);
  color: var(--text-muted);
  font-family: var(--font-figure);
}

.input {
  flex: 1;
  inline-size: 100%;
  min-inline-size: 4rem;
  /* The same 10px / 14px as every other text field (`APP-013`). The `.control` wrapper
     carries the border, the radius and the 44px minimum. */
  padding: 0.625rem 0.875rem;
  border: 0;
  background: transparent;
  color: var(--text);
  font-size: var(--text-lg);
}

/* The control already carries the ring via :focus-within; a second one would double up. */
.input:focus-visible {
  outline: none;
}

.input:disabled {
  color: var(--text-muted);
  cursor: not-allowed;
}

.control:has(.input[aria-invalid="true"]) {
  border-color: var(--danger);
  /* A second, thicker edge so the invalid state survives a monochrome or high-contrast
     rendering, where the danger hue alone would carry nothing. */
  border-inline-start-width: 3px;
}

.hint {
  font-size: var(--text-sm);
  color: var(--text-muted);
  max-inline-size: var(--measure);
}

.error {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--danger);
  max-inline-size: var(--measure);
}

.marker {
  inline-size: 16px;
  block-size: 16px;
  flex: none;
  margin-block-start: 0.2em;
}
